// extracted by mini-css-extract-plugin
export default {"badge":"ManageModalBadge_badge__M0kdf","dateBadge":"ManageModalBadge_dateBadge__Fu+qT"};